<script lang="ts" setup></script>

<template>
  <span>
    <span :class="$style.title__dots">結婚資金</span>について<br />
    こんなこと悩んでいませんか？
  </span>
</template>

<style lang="scss" module>
.title {
  &__dots {
    -webkit-text-emphasis: filled $color-surface-accent-primary;
    text-emphasis: filled $color-surface-accent-primary;
  }
}
</style>
